<div class="_content">
    <div #content>
        <ng-content></ng-content>
    </div>
</div>